// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__1s3lv","pencil":"IconEdit_pencil__z9WPM"};